import * as Yup from 'yup';
export const signUpSchema = Yup.object().shape({
  email: Yup.string().email(),
  fullName: Yup.string().required('نام  و نام خانوادگی اجباری می باشد'),
  province: Yup.object().required('استان اجباری می باشد'),
  city: Yup.object().required(' شهراجباری می باشد'),
});